var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99967 15.1667C4.04634 15.1667 0.833008 11.9533 0.833008 8.00001C0.833008 4.04668 4.04634 0.833344 7.99967 0.833344C11.953 0.833344 15.1663 4.04668 15.1663 8.00001C15.1663 11.9533 11.953 15.1667 7.99967 15.1667ZM7.99967 1.83334C4.59967 1.83334 1.83301 4.60001 1.83301 8.00001C1.83301 11.4 4.59967 14.1667 7.99967 14.1667C11.3997 14.1667 14.1663 11.4 14.1663 8.00001C14.1663 4.60001 11.3997 1.83334 7.99967 1.83334Z",
    fill: "#17B26A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.05297 10.3867C6.91964 10.3867 6.79297 10.3333 6.69964 10.24L4.81297 8.35334C4.61964 8.16 4.61964 7.84 4.81297 7.64667C5.0063 7.45334 5.3263 7.45334 5.51964 7.64667L7.05297 9.18L10.4796 5.75334C10.673 5.56 10.993 5.56 11.1863 5.75334C11.3796 5.94667 11.3796 6.26667 11.1863 6.46L7.4063 10.24C7.31297 10.3333 7.1863 10.3867 7.05297 10.3867Z",
    fill: "#17B26A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.ed99b395bfdaa0b00dbfecc6bc6e7b18.svg";
export { ForwardRef as ReactComponent };